import React, { useState } from "react";
import { baseURL } from "../../util/Constant";

export const ShowImgStatus = ({ url, setShowItems, loadingImage }) => {
  const [isLoading, setIsLoading] = useState(true);
  const isTauri = window.__TAURI__ !== undefined;

  const handleCloseImage = (e) => {
    e.stopPropagation();
    setShowItems(false);
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  if (!url || !url.imgStatus || !Array.isArray(url.imgStatus)) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000073] z-50 " onClick={handleCloseImage}>
      <div className="w-[600px] m-auto my-[5%] bg-white rounded-lg py-[15px] px-[15px]">
        {!loadingImage && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          </div>
        )}
        <div className="text-center text-2xl">
          {loadingImage && url?.order}
        </div>
        {loadingImage && (
          <div className="grid gap-4 overflow-x-auto overflow-y-auto max-h-[80vh]">
            {url.imgStatus.map((item, index) => (
              <div key={index} className="flex flex-col items-center w-auto h-auto">
                <img 
                  src={item?.fileId ? `${baseURL}/image/file/${item.fileId}` : `data:image/jpeg;base64,${item.image}`}
                  alt="" 
                  className="w-auto h-auto"
                  onLoad={handleImageLoad}
                  style={{ opacity: isLoading ? 0 : 1 }}
                />
                <div className="mt-2 text-sm text-gray-500">
                  {"URL: "+item.path}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
